import styles from './LandingLayout.module.css';

const PrivacyPage = () => (
  <section className={styles.section}>
    <div className={styles.sectionInner}>
      <div className={styles.sectionLabel}>Legal</div>
      <h2 className={styles.sectionTitle}>Privacy Policy</h2>
      <div className={styles.legalBody}>
        <p><strong>Effective Date:</strong> 1 January 2026</p>
        <p><strong>Last Updated:</strong> June 2026</p>
        <p>
          JainamSevaSetu is a software platform for managing donations and funding for Jain community temples.
          This Privacy Policy explains how we collect, use, and protect your personal information when you use our platform,
          in compliance with the Information Technology Act, 2000, the IT (Intermediary Guidelines and Digital Media Ethics Code) Rules, 2021,
          and the Digital Personal Data Protection Act (DPDPA), 2023.
        </p>

        <h3>1. Data Controller</h3>
        <p>
          The data controller responsible for your personal information is the <strong>JainamSevaSetu</strong> team.
          For any privacy-related queries, you may contact us at{' '}
          <a href="mailto:jainamsevasetu@gmail.com">jainamsevasetu@gmail.com</a>.
        </p>

        <h3>2. Information We Collect</h3>
        <p>We collect information you provide when registering an account, including your name, email address, and phone number. Derasar Administrators may also manually enter donation records, financial data, and personal details of community members on behalf of those individuals. By doing so, the Administrator explicitly warrants that they have obtained the explicit and lawful consent of each such individual prior to entering their data onto the Platform. JainamSevaSetu acts as an intermediary and does not independently verify the accuracy or lawfulness of data entered by Administrators.</p>

        <h3>3. How We Use Your Information</h3>
        <p>Your information is used solely to operate and improve the platform: authenticate your identity, display your contribution history, generate reports for your Derasar, and send account-related emails such as email verification and password reset.</p>

        <h3>4. Data Sharing</h3>
        <p>We do not sell or rent your personal data to any third party. Your data is visible only to you and the admin(s) of the Derasar(s) you are a member of. Platform admins at JainamSevaSetu can access platform-level statistics but cannot read individual donation records.</p>

        <h3>5. Intermediary Status</h3>
        <p>JainamSevaSetu operates strictly as a software tool and IT intermediary under the Information Technology Act, 2000. We provide the infrastructure for Derasar Administrators and members to record and manage financial data. We do not independently create, curate, or verify the financial or personal data entered by users. Accordingly, we are not liable for inaccuracies, misrepresentations, or unlawful entries made by users or administrators on the Platform.</p>

        <h3>6. Data Security</h3>
        <p>Passwords are hashed using bcrypt before storage. All data is stored on encrypted cloud infrastructure. We use industry-standard HTTPS for all data in transit.</p>

        <h3>7. Data Retention</h3>
        <p>Your account data is retained for as long as your account is active. For Derasars operating under a paid subscription, if the subscription lapses, we will retain your Derasar's financial data for a grace period of 90 days from the date of lapse. If the subscription is not renewed within this period, the data will be permanently and securely deleted from our infrastructure. You may also request deletion of your account and associated personal data at any time by contacting us at the address below.</p>

        <h3>8. Cookies &amp; Local Storage</h3>
        <p>We use browser localStorage to maintain your login session and theme preference. We do not use third-party tracking cookies or advertising trackers.</p>

        <h3>9. Your Rights</h3>
        <p>Under the Information Technology Act, 2000 and the Digital Personal Data Protection Act (DPDPA), 2023, you have the right to access, correct, or request deletion of the personal data we hold about you. To exercise these rights, contact <a href="mailto:jainamsevasetu@gmail.com">jainamsevasetu@gmail.com</a>. We will acknowledge your request within 48 hours and aim to fulfill it within 15 business days.</p>

        <h3>10. Grievance Redressal Mechanism</h3>
        <p>
          In compliance with the Information Technology Act, 2000 and the IT (Intermediary Guidelines) Rules, 2021, any grievances,
          complaints, or notices regarding this Privacy Policy or the handling of your personal data may be directed to our designated Grievance Officer:
        </p>
        <p>
          <strong>Grievance Officer:</strong> JainamSevaSetu Team<br />
          <strong>Email:</strong> <a href="mailto:jainamsevasetu@gmail.com">jainamsevasetu@gmail.com</a><br />
          <strong>Acknowledgement:</strong> Within 48 hours of receipt<br />
          <strong>Resolution:</strong> Within 15 business days
        </p>

        <h3>11. Contact</h3>
        <p>
          <strong>JainamSevaSetu</strong><br />
          Email: <a href="mailto:jainamsevasetu@gmail.com">jainamsevasetu@gmail.com</a>
        </p>
      </div>
    </div>
  </section>
);

export default PrivacyPage;
